import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--ink))] text-[hsl(var(--bg))] relative overflow-hidden"
    >
      <div className="container-x pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="display text-4xl md:text-5xl leading-none">
              ESRA<span className="text-[hsl(var(--ocre))]">.</span>
            </div>
            <div className="text-[11px] uppercase tracking-[0.28em] mt-3 text-[hsl(var(--bg))]/60">
              S.R.L.S. — Torino, Italia
            </div>
            <p className="mt-8 max-w-md text-[hsl(var(--bg))]/70 leading-relaxed text-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[hsl(var(--ocre))]">{t.footer.navTitle}</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="link-underline" data-testid="footer-nav-home">{t.nav.home}</Link></li>
              <li><Link to="/services" className="link-underline" data-testid="footer-nav-services">{t.nav.services}</Link></li>
              <li><Link to="/about" className="link-underline" data-testid="footer-nav-about">{t.nav.about}</Link></li>
              <li><Link to="/contact" className="link-underline" data-testid="footer-nav-contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-[hsl(var(--ocre))]">{t.footer.contactTitle}</div>
            <address className="not-italic mt-5 text-sm leading-relaxed whitespace-pre-line text-[hsl(var(--bg))]/80">
              {t.footer.address}
            </address>
            <div className="mt-4 space-y-1 text-sm text-[hsl(var(--bg))]/80">
              <a href="mailto:contact@esra_srls.com" className="link-underline block" data-testid="footer-email">contact@esra_srls.com</a>
              <a href="tel:+393662689583" className="link-underline block" data-testid="footer-phone">+39 366 2689583</a>
            </div>
          </div>
        </div>

        <div className="hairline opacity-20 mt-16" />

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--bg))]/60">
          <div>© {year} ESRA S.R.L.S. — {t.footer.rights}</div>
          <div className="flex flex-wrap items-center gap-6">
            <Link to="/legal" className="link-underline" data-testid="footer-legal">{t.footer.legal}</Link>
            <Link to="/terms" className="link-underline" data-testid="footer-terms">{t.footer.terms}</Link>
            <LanguageSwitcher variant="light" />
          </div>
        </div>
      </div>

      {/* huge wordmark accent */}
      <div className="pointer-events-none select-none absolute -bottom-10 -right-6 md:-bottom-20 md:-right-12 opacity-[0.04] text-[28vw] md:text-[18vw] leading-none display">
        ESRA
      </div>
    </footer>
  );
}
